import { assertTokenValidForMutation, handleResponse } from "./service-helpers";

const NBH_PREFILL_ADMIN_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/organization-settings/prefill-member-address`;
const NBH_PREFILL_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/options/prefill-member-address`;

export interface PrefillMemberAddressResponse {
    enabled: boolean;
}

export async function getPrefillMemberAddressFromOrg(token: string): Promise<boolean> {
    const response = await fetch(NBH_PREFILL_USER_URL, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    const data = await handleResponse<PrefillMemberAddressResponse>(response) as PrefillMemberAddressResponse;
    return data.enabled;
}

export async function updatePrefillMemberAddressFromOrg(token: string, enabled: boolean): Promise<boolean> {
    assertTokenValidForMutation()
    const response = await fetch(NBH_PREFILL_ADMIN_URL, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ enabled })
    });

    const data = await handleResponse<PrefillMemberAddressResponse>(response) as PrefillMemberAddressResponse;
    return data.enabled;
}
